import { Document } from "@components/documents/types";

export const CURRENT_DOC = "CURRENT_DOC";
export const DEFAULT_CATEGORY = "Word Document";
export const DEFAULT_TYPE = "docx";
const CURRENT_DOCUMENT_NAME = "Current Document";

export const CURRENT_DOC_ITEM: Document = {
  id: CURRENT_DOC,
  name: CURRENT_DOCUMENT_NAME,
  label: CURRENT_DOCUMENT_NAME,
  type: DEFAULT_TYPE,
  category: DEFAULT_CATEGORY,
  source_path: null,
};
